import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {veilString} from '@src/helpers/veil-string';

export default class SensitiveColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn, Model> {
    protected get value(): any {
        const value = super.value;

        return value ? veilString(String(value)) : value;
    }
}
